
import { MapTo } from '@adobe/aem-react-editable-components';
import CorporateNavigationLinks, { CorporateNavigationLinksEditConfig } from './CorporateNavigationLinks';

export default MapTo('cob-corp-acquisition/components/creditonebank/corporate-navigation-links')(CorporateNavigationLinks, CorporateNavigationLinksEditConfig);
        